import { SimpleForm, required, useTranslate } from "react-admin";
import React from "react";
import { Group, GroupTitle, Toolbar } from "ra-friendsofbabba";
import { FileInput } from "../component/input";

const Form = (props) => {
  const translate = useTranslate();
  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backReferenceTarget="intermediate_technical_report_id"
          backReference="intermediate-technical-reports"
          backTab={0}
        />
      }
    >
      <Group wrapper>
        <GroupTitle
          title={translate(
            "resources.intermediate-technical-report-docs.name",
            { smart_count: 1 }
          )}
        />
        <FileInput source="file" validate={required()} />
      </Group>
    </SimpleForm>
  );
};
export default Form;
